// extracted by mini-css-extract-plugin
export default {"container":"ProBenefits_container__ZdO-T","benefits":"ProBenefits_benefits__8NjG9","card":"ProBenefits_card__9NY-2","description":"ProBenefits_description__ye+5Y"};